import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "price-options" }
const _hoisted_3 = { class: "option-item" }
const _hoisted_4 = { class: "option-content" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "option-item" }
const _hoisted_7 = { class: "option-content" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "option-item" }
const _hoisted_10 = { class: "option-content" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "option-item" }
const _hoisted_13 = { class: "option-content" }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "dollar-amount-section"
}
const _hoisted_16 = { class: "amount-input-wrapper" }
const _hoisted_17 = { class: "controls" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal-title" }, "Edit Price", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                id: "fixed-amount",
                type: "radio",
                value: $setup.PriceType.FIXED,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.priceType) = $event)),
                name: "pricing-type"
              }, null, 8, _hoisted_5), [
                [_vModelRadio, $setup.priceType]
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("label", { for: "fixed-amount" }, "Fixed dollar amount", -1))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "example-text" }, "Example: $300,000", -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                id: "display-from",
                type: "radio",
                value: $setup.PriceType.FROM,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.priceType) = $event)),
                name: "pricing-type"
              }, null, 8, _hoisted_8), [
                [_vModelRadio, $setup.priceType]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "display-from" }, "Display 'From' prefix before price", -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "example-text" }, "Example: From $300,000", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                id: "hide-pricing",
                type: "radio",
                value: $setup.PriceType.HIDE,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.priceType) = $event)),
                name: "pricing-type"
              }, null, 8, _hoisted_11), [
                [_vModelRadio, $setup.priceType]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("label", { for: "hide-pricing" }, "Hide pricing altogether", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                id: "open-offers",
                type: "radio",
                value: $setup.PriceType.OFFERS,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.priceType) = $event)),
                name: "pricing-type"
              }, null, 8, _hoisted_14), [
                [_vModelRadio, $setup.priceType]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "open-offers" }, "Open to Offers", -1))
            ])
          ])
        ]),
        ($setup.showPriceValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Price", -1)),
              _createElementVNode("div", _hoisted_16, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "currency-symbol" }, "$", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "amount-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.priceValue) = $event)),
                  placeholder: "300000",
                  onInput: $setup.formatPrice
                }, null, 544), [
                  [_vModelText, $setup.priceValue]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "button default cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: _normalizeClass(["button default primary v2 save", { disabled: !$setup.isFormValid }]),
            onClick: $setup.save,
            disabled: !$setup.isFormValid
          }, "Save", 10, _hoisted_18)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}